import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TopBar from './top-bar';
import Menu from './menu';

class Header extends Component {
  render () {
    return (
      <main>
        <TopBar />
        <Menu />
      </main>
    )
  }
}

Header.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default Header;
